<template>
  <div
    :key="`${row_sync.lotId}-${header.field.id}-hover-add-data`"
    class="additional-field-td"
    :class="{'disabled': disabled || header.disable, 'empty': !existsValue && type !== 'CHECKBOX'}"
    :data-qa="`table-row-${index}-additional_field-${header.field.id}`">
    <template
      v-if="header.disable">
      <div
        class="additional-field-td__content"
        :class="{'disabled': disabled || header.disable, 'pre': type == 'TEXT'}">
        {{ formatted }}
      </div>
    </template>
    <template
      v-else-if="type == 'CHECKBOX'">
      <div class="flex align-center justify-center">
        <sCheckbox
          :key="`${row_sync.lotId}-${header.field.id}-${value}-checkbox`"
          v-model="value"
          class="additional-field__checkbox mx-4"
          data-qa="additional-field__checkbox"
          :false-label="'false'"
          :true-label="'true'"/>
      </div>
    </template>
    <sPopover
      v-else
      v-model="showMenu"
      :disabled="disabled || header.disable"
      placement="bottom"
      :style-root="'margin: auto;'">
      <AdditionalFieldTdMenu
        v-if="showMenu"
        :field.sync="field_sync"
        :index="index"
        :positions.sync="positions_sync"
        @change="() => changeStateAdditionalFieldBlock()"/>
      <div
        slot="reference"
        class="additional-field-td__content"
        :class="{'disabled': disabled || header.disable, 'text-left pl-6 pr-2' : existsValue}">
        <span
          v-if="existsValue">{{ formatted }}</span>
        <sButton
          v-else
          slot="reference"
          class="additional-field-td__button px-2"
          :disabled="disabled || showMenu"
          icon="plus"
          small
          style="--btn-color: #465856;"
          type="text">
          {{ $t('Common.Add') }}
        </sButton>
      </div>
    </sPopover>
  </div>
</template>
<script>
import { modalMixin } from 'mixins'
import AdditionalFieldTdMenu from 'components/additional fields/AdditionalFieldTdMenu.vue'

export default {
  name: 'additionalFieldTd',
  mixins: [ modalMixin ],
  data() {
    return {
      showMenu: false,
    }
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    header: {
      type: Object
    },
    positions: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number
    },
    disabled: Boolean
  },
  computed: {
    row_sync: {
      get() {
        return this.row
      },
      set(val) {
        this.$emit('update:row',  val)
      }
    },
    positions_sync: {
      get() {
        return this.positions
      },
      set(newValue) {
        this.$emit('update:positions', newValue)
      }
    },
    field_sync: {
      get() {
        return this.row_sync?.additional_fields?.[this.header?.field?.id]
      },
      set(val) {
        const result = this.$_.cloneDeep(this.row_sync)
        result.additional_fields = result.additional_fields ?? {}
        result.additional_fields[this.header.field.id] = val
        this.row_sync = result
      }
    },
    value: {
      get() {
        return this.field_sync?.value
      },
      set(val) {
        this.field_sync.value = val
      }
    },
    type() {
      return this.field_sync?.typeId || this.field_sync?.type?.typeId
    },
    formatted() {
      return this.type == 'DATE_TIME' ? this.formatBy(this.value, 'DD.MM.YYYY') : this.value
    },
    existsValue() {
      if (this.type == 'DATE_TIME') {
        return !!this.value
      }
      if (this.type == 'CHECKBOX') {
        return this.value !== ''
      }
      return this.formatted
    }
  },
  methods: {
    changeStateAdditionalFieldBlock() {
      //this.$emit('checkFields')
      this.$emit('changeField')
      //this.$forceUpdate()
      this.showMenu = false
    },
  },
  components: {
    AdditionalFieldTdMenu
  }
}
</script>
<style lang="scss">
.additional-field-td {
  text-align: center;
  height: 100%;
  display: contents;
  &:not(.disabled):hover,
  &:not(.disabled):focus {
    & .additional-field-td__button {
      opacity: 1;
    }
  }
  &.empty {
    display: flex;
  }
  &.disabled {
    background-color: var(--v-secondary__green_chosen-base) !important;
  }
  & .additional-field-td__button {
    opacity: 0;
  }
  &__content.disabled {
    height: 100%;
    display: flex;
    align-items: center;
    background-color: var(--v-secondary__green_chosen-base) !important;
  }
}

</style>
